<template lang="pug">
div
  hr(style="width: 95%;margin: 4vw 2.5vw;")
  .title(style="line-height: 160vw;")
    div
    span {{title}}
    // div
    div(style="margin-top: 80vw;")
      router-link(:to={name:'info'})
        center
          a(class="ht-header-bttn ht-mobile-hide" size="mini" type="primary") 立即預約
//   div(v-if="isDetailGood" @click="switchArea")
//     //-  img(src="@/assets/home.png")
//   div(v-else @click="switchArea")
//     .count {{countInCart}}
//     img(src="@/assets/cart.png")

</template>

<script>
export default {
  data () {
    return {
      title: '我的訂單'
    }
  }
}
</script>
<style lang="scss" scoped>
// .count {
//   position: absolute;
//   top: 0;
//   right: 7px;
//   width: 15px;
//   height: 15px;
//   font-size: 12px;
//   line-height: 15px;
//   background: red;
//   color: #f1f2f1;
//   text-align: center;
//   border-radius: 50%;
// }
</style>
